module.exports = __webpack_public_path__ + "static/media/travel-responsive.4cb88725.png";